// const basicParams = {
//   	teamId:"",  // 团队ID
//     datasetId: "",  // 数据集ID
//     taskId: "",  // 任务ID
//     tool:"",  // 如果是工具分析，判断来自于什么工具
//     source: "TF_regulation_run", // 数据来源标识
//     appId:"analyze",   // 指定去解读（Interpret）或者绘图（Plot）或者分析（Analyze）
//     query: "提交一个pySENIC转录调控分析任务",  // 初始指定查询内容，需要中英翻译
// };


/**
 * 指定去解读（Interpret）或者绘图（Plot）或者分析（Analyze）
 */
const simonModules = {
  analyze: 'analyzer',
  plot: 'plotter',
  interpret: 'interpreter',
};

export const simonTransferTypes = {
  topNav: 'topNav',
  drawingTools: 'drawingTools',
  differentialAnalysis1: 'differentialAnalysis1',
  differentialAnalysis2: 'differentialAnalysis2',
  pathwayAnalysis: 'pathwayAnalysis',
  cellInteractions1: 'cellInteractions1',
  cellInteractions2: 'cellInteractions2',
  cellInteractions3: 'cellInteractions3',
  trajectoryAnalysis1: 'trajectoryAnalysis1',
  trajectoryAnalysis2: 'trajectoryAnalysis2',
  trajectoryAnalysis3: 'trajectoryAnalysis3',
  trajectoryAnalysis4: 'trajectoryAnalysis4',
  trajectoryAnalysis5: 'trajectoryAnalysis5',
  trajectoryAnalysis6: 'trajectoryAnalysis6',
  trajectoryAnalysis7: 'trajectoryAnalysis7',
  trajectoryAnalysis8: 'trajectoryAnalysis8',
  CNVAnalysis1: 'CNVAnalysis1',
  CNVAnalysis2: 'CNVAnalysis2',
  ITHAnalysis1: 'ITHAnalysis1',
  ITHAnalysis2: 'ITHAnalysis2',
  TFRegulationAnalysis1: 'TFRegulationAnalysis1',
  TFRegulationAnalysis2: 'TFRegulationAnalysis2',
  TFRegulationAnalysis3: 'TFRegulationAnalysis3',

};


/**
 * 所有需要触发simon询问的对象列表
 */
const simonTransferObjList = {
  topNav: {
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "", // 数据来源标识
    appId: '',   // 指定去解读（Interpret）或者绘图（Plot）或者分析（Analyze）
    query: "",  // 初始指定查询内容，需要中英翻
  },
  drawingTools: {  // 绘图工具
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "", // 数据来源标识
    appId: '',   // 指定去解读（Interpret）或者绘图（Plot）或者分析（Analyze）
    query: "Simon.Drawing.Tools.Pre.Question",  // 初始指定查询内容，需要中英翻
  },
  differentialAnalysis1: {  // 差异分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "differential_analysis_run", // 数据来源标识
    appId: simonModules.analyze,   // 指定去解读（Interpret）或者绘图（Plot）或者分析（Analyze）
    query: "Simon.Differential.Expression.Pre.Question1",  // 初始指定查询内容，需要中英翻
  },
  differentialAnalysis2: {  // 差异分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "differential_analysis_result1", // 数据来源标识
    appId: simonModules.interpret,   
    query: "Simon.Differential.Expression.Pre.Question2",  // 初始指定查询内容，需要中英翻
  },
  pathwayAnalysis: {  // 通路分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "pathway_analysis_result", // 数据来源标识
    appId: simonModules.interpret,   // 指定去解读（Interpret）或者绘图（Plot）或者分析（Analyze）
    query: "Simon.Differential.Expression.Pre.Question3",  // 初始指定查询内容，需要中英翻
  },
  cellInteractions1: {  // 细胞互作分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "cell_interactions_analysis_run", // 数据来源标识
    appId: simonModules.analyze,   // 指定去解读（Interpret）或者绘图（Plot）或者分析（Analyze）
    query: "Simon.Cell.Interactions.Pre.Question1",  // 初始指定查询内容，需要中英翻
  },
  cellInteractions2: {  // 细胞互作分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "cell_interactions_analysis_result1", // 数据来源标识
    appId: simonModules.interpret,   // 指定去解读（interpret）或者绘图（Plot）或者分析（Analyze）
    query: "Simon.Cell.Interactions.Pre.Question2",  // 初始指定查询内容，需要中英翻
  },
  cellInteractions3: {  // 互作对比可视化分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "cell_interactions_analysis_result2", // 数据来源标识
    appId: simonModules.interpret,   // 指定去解读（interpret）或者绘图（Plot）或者分析（Analyze）
    query: "Simon.Cell.Interactions.Pre.Question3",  // 初始指定查询内容，需要中英翻
  },
  trajectoryAnalysis1: {  // 轨迹分析 Monocle2
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "trajectory_analysis_run", // 数据来源标识
    appId: simonModules.analyze,  
    query: "Simon.Trajectory.Analysis.Pre.Question1",  // 初始指定查询内容，需要中英翻
  },
  trajectoryAnalysis2: {  // 轨迹分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "trajectory_analysis_run", // 数据来源标识
    appId: simonModules.analyze,  
    query: "Simon.Trajectory.Analysis.Pre.Question2",  // 初始指定查询内容，需要中英翻
  },
  trajectoryAnalysis3: {  // 轨迹分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "trajectory_analysis_run", // 数据来源标识
    appId: simonModules.analyze,  
    query: "Simon.Trajectory.Analysis.Pre.Question3",  // 初始指定查询内容，需要中英翻
  },
  trajectoryAnalysis4: {  // 轨迹分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "trajectory_analysis_result1", // 数据来源标识
    appId: simonModules.interpret,  
    query: "Simon.Trajectory.Analysis.Pre.Question4",  // 初始指定查询内容，需要中英翻
  },
  trajectoryAnalysis5: {  // 轨迹分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "trajectory_analysis_result2", // 数据来源标识
    appId: simonModules.interpret,  
    query: "Simon.Trajectory.Analysis.Pre.Question5",  // 初始指定查询内容，需要中英翻
  },
  trajectoryAnalysis6: {  // 轨迹分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "trajectory_analysis_result3", // 数据来源标识
    appId: simonModules.interpret,  
    query: "Simon.Trajectory.Analysis.Pre.Question6",  // 初始指定查询内容，需要中英翻
  },
  trajectoryAnalysis7: {  // 轨迹分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "trajectory_analysis_result4", // 数据来源标识
    appId: simonModules.interpret,  
    query: "Simon.Trajectory.Analysis.Pre.Question7",  // 初始指定查询内容，需要中英翻
  },
  trajectoryAnalysis8: {  // 轨迹分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "trajectory_analysis_result5", // 数据来源标识
    appId: simonModules.interpret,  
    query: "Simon.Trajectory.Analysis.Pre.Question8",  // 初始指定查询内容，需要中英翻
  },
  CNVAnalysis1: {  // 拷贝数变化分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "cnv_analysis_run", // 数据来源标识
    appId: simonModules.analyze,  
    query: "Simon.CNV.Analysis.Pre.Question1",  // 初始指定查询内容，需要中英翻
  },
  CNVAnalysis2: {  // 拷贝数变化分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "cnv_analysis_result", // 数据来源标识
    appId: simonModules.interpret,  
    query: "Simon.CNV.Analysis.Pre.Question2",  // 初始指定查询内容，需要中英翻
  },
  ITHAnalysis1: {  // ITH分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "ith_analysis_run", // 数据来源标识
    appId: simonModules.analyze,  
    query: "Simon.ITH.Analysis.Pre.Question1",  // 初始指定查询内容，需要中英翻
  },
  ITHAnalysis2: {  // ITH分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "ith_analysis_result", // 数据来源标识
    appId: simonModules.interpret,  
    query: "Simon.ITH.Analysis.Pre.Question2",  // 初始指定查询内容，需要中英翻
  },
  TFRegulationAnalysis1: {  // 转录调控分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "tf_regulation_analysis_run", // 数据来源标识
    appId: simonModules.analyze,  
    query: "Simon.TF.Regulation.Analysis.Pre.Question1",  // 初始指定查询内容，需要中英翻
  },
  TFRegulationAnalysis2: {  // 转录调控分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "tf_regulation_analysis_result", // 数据来源标识
    appId: simonModules.interpret,  
    query: "Simon.TF.Regulation.Analysis.Pre.Question2",  // 初始指定查询内容，需要中英翻
  },
  TFRegulationAnalysis3: {  // 转录调控分析
    teamId:"",  // 团队ID
    datasetId: "",  // 数据集ID
    taskId: "",  // 任务ID
    tool:"",  // 如果是工具分析，判断来自于什么工具
    source: "tf_regulation_analysis_result", // 数据来源标识
    appId: simonModules.interpret,  
    query: "Simon.TF.Regulation.Analysis.Pre.Question3",  // 初始指定查询内容，需要中英翻
  },
};
import store from "@/store";
import router from "@/router";

/**
 * 获取SimonTransfer对象列表
 * @param {string} type - SimonTransfer对象类型
 * @param {string} datasetId - 数据集ID
 * @param {string} taskId - 任务ID
 * @returns {object} SimonTransfer对象
 */
export function getSimonTransferObj(type, datasetId = "", taskId = "", tool = "") {
  const item = simonTransferObjList[type];
  item.teamId = store.state.user.teamId;
  item.datasetId = datasetId;
  item.taskId = taskId;
  item.tool = tool;
  handleToSimonAI(item);
}

/**
 * 处理绘图工具的AI请求
 * @param {*} obj {tool: string, source: string, appId: string}
 * 
 */
export function handleDrawingToolsAI(obj) {
  const item = simonTransferObjList[simonTransferTypes.drawingTools];
  item.teamId = store.state.user.teamId;
  item.source = obj.source;
  item.appId = obj.appId;
  item.tool = obj.tool;
  handleToSimonAI(item);
}

function handleToSimonAI(item) {
  const {href} = router.resolve({
    path: '/simon',
    query: {
      ...item,
    },
  });
  window.open(href, '_blank');
}

